// You can write more code here

/* START OF COMPILED CODE */

import UIBlocker from "../GeneralUI/UIBlocker";
import MentorUI from "../GeneralUI/MentorUI";
import DefaultButton from "../GeneralUI/Buttons/DefaultButton";
import DefaultDenyButton from "../GeneralUI/Buttons/DefaultDenyButton";
import DefaultConfirmButton_m from "../DefaultConfirmButton_m";
import DefaultDenyButton_m from "../GeneralUI/Buttons/DefaultDenyButton_m";
/* START-USER-IMPORTS */
import { ResponsivenessManager } from '@/game/GameComponents/PhaserGame/Managers/ResponsivenessManager';
import { PhaserAudioManager } from '@/game/GameComponents/PhaserGame/Utils/PhaserAudioManager';
import { getAnchorPlugin } from '@/game/GameComponents/PhaserGame/Utils/PhaserUtils';
/* END-USER-IMPORTS */

export default class NextLevelModal extends Phaser.GameObjects.Container {

	constructor(scene: Phaser.Scene, x?: number, y?: number) {
		super(scene, x ?? 0, y ?? 0);

		// uIBlocker
		const uIBlocker = new UIBlocker(scene, 0, 0);
		this.add(uIBlocker);

		// desktopView
		const desktopView = scene.add.container(0, 0);
		desktopView.visible = false;
		this.add(desktopView);

		// mainContainer
		const mainContainer = scene.add.container(512, 384);
		desktopView.add(mainContainer);

		// mentorUI
		const mentorUI = new MentorUI(scene, -272, 0);
		mentorUI.scaleX = 0.35;
		mentorUI.scaleY = 0.35;
		mainContainer.add(mentorUI);

		// backing
		const backing = scene.add.nineslice(0, 0, "Hud1", undefined, 116, 52, 8, 8, 8, 8);
		backing.scaleX = 4;
		backing.scaleY = 4;
		mainContainer.add(backing);

		// yesButton
		const yesButton = new DefaultButton(scene, -112, 48);
		yesButton.scaleX = 1;
		yesButton.scaleY = 1;
		mainContainer.add(yesButton);

		// bitmaptext_1
		const bitmaptext_1 = scene.add.bitmapText(0, -11, "Aronui", "Proceed to the next level?");
		bitmaptext_1.setOrigin(0.5, 0.5);
		bitmaptext_1.tintTopLeft = 5387071;
		bitmaptext_1.tintTopRight = 5387071;
		bitmaptext_1.tintBottomLeft = 5387071;
		bitmaptext_1.tintBottomRight = 5387071;
		bitmaptext_1.text = "Proceed to the next level?";
		bitmaptext_1.fontSize = -14;
		bitmaptext_1.align = 1;
		bitmaptext_1.maxWidth = 250;
		mainContainer.add(bitmaptext_1);

		// bitmaptext
		const bitmaptext = scene.add.bitmapText(0, -43, "Aronui", "Level Complete");
		bitmaptext.setOrigin(0.5, 0.5);
		bitmaptext.tintTopLeft = 985612;
		bitmaptext.tintTopRight = 985612;
		bitmaptext.tintBottomLeft = 985612;
		bitmaptext.tintBottomRight = 985612;
		bitmaptext.text = "Level Complete";
		bitmaptext.fontSize = -30;
		bitmaptext.align = 1;
		bitmaptext.maxWidth = 250;
		mainContainer.add(bitmaptext);

		// noButton
		const noButton = new DefaultDenyButton(scene, 112, 48);
		mainContainer.add(noButton);

		// mobileView
		const mobileView = scene.add.container(0, 0);
		this.add(mobileView);

		// mainContainer_m
		const mainContainer_m = scene.add.container(339, 187.5);
		mobileView.add(mainContainer_m);

		// backing_m
		const backing_m = scene.add.nineslice(0, 0, "Hud1", undefined, 232, 104, 8, 8, 8, 8);
		backing_m.scaleX = 2;
		backing_m.scaleY = 2;
		mainContainer_m.add(backing_m);

		// bitmaptext_1_m
		const bitmaptext_1_m = scene.add.bitmapText(0, -11, "Aronui", "Proceed to the next level?");
		bitmaptext_1_m.setOrigin(0.5, 0.5);
		bitmaptext_1_m.tintTopLeft = 5387071;
		bitmaptext_1_m.tintTopRight = 5387071;
		bitmaptext_1_m.tintBottomLeft = 5387071;
		bitmaptext_1_m.tintBottomRight = 5387071;
		bitmaptext_1_m.text = "Proceed to the next level?";
		bitmaptext_1_m.fontSize = -14;
		bitmaptext_1_m.align = 1;
		bitmaptext_1_m.maxWidth = 250;
		mainContainer_m.add(bitmaptext_1_m);

		// bitmaptext_m
		const bitmaptext_m = scene.add.bitmapText(0, -43, "Aronui", "Level Complete");
		bitmaptext_m.setOrigin(0.5, 0.5);
		bitmaptext_m.tintTopLeft = 985612;
		bitmaptext_m.tintTopRight = 985612;
		bitmaptext_m.tintBottomLeft = 985612;
		bitmaptext_m.tintBottomRight = 985612;
		bitmaptext_m.text = "Level Complete";
		bitmaptext_m.fontSize = -30;
		bitmaptext_m.align = 1;
		bitmaptext_m.maxWidth = 250;
		mainContainer_m.add(bitmaptext_m);

		// yesButton_m
		const yesButton_m = new DefaultConfirmButton_m(scene, -112, 48);
		mainContainer_m.add(yesButton_m);

		// noButton_m
		const noButton_m = new DefaultDenyButton_m(scene, 112, 48);
		mainContainer_m.add(noButton_m);

		// yesButton (prefab fields)
		yesButton.buttonText = "Yes";

		// noButton (prefab fields)
		noButton.buttonText = "No";

		// yesButton_m (prefab fields)
		yesButton_m.buttonText = "Yes";

		// noButton_m (prefab fields)
		noButton_m.buttonText = "No";

		this.yesButton = yesButton;
		this.noButton = noButton;
		this.mainContainer = mainContainer;
		this.desktopView = desktopView;
		this.yesButton_m = yesButton_m;
		this.noButton_m = noButton_m;
		this.mainContainer_m = mainContainer_m;
		this.mobileView = mobileView;
		// awake handler
		this.scene.events.once("scene-awake", () => this.awake());

		/* START-USER-CTR-CODE */
    this.handleCompleteCurrentLevel = () => {};

    /* END-USER-CTR-CODE */
	}

	public yesButton: DefaultButton;
	public noButton: DefaultDenyButton;
	private mainContainer: Phaser.GameObjects.Container;
	public desktopView: Phaser.GameObjects.Container;
	public yesButton_m: DefaultConfirmButton_m;
	public noButton_m: DefaultDenyButton_m;
	private mainContainer_m: Phaser.GameObjects.Container;
	public mobileView: Phaser.GameObjects.Container;

	/* START-USER-CODE */
  handleCompleteCurrentLevel: () => void;

  getResponsiveElements(key: keyof NextLevelModal) {
    return ResponsivenessManager.GetAllResponsiveComponentsFromContainer(
      this,
      key,
    );
  }

  awake() {
    this.getResponsiveElements('yesButton').forEach(
      (yesButton: DefaultButton) => {
        yesButton.controller.setSubmissionCallback(() => {
          this.handleCompleteCurrentLevel();
        });
      },
    );

    this.getResponsiveElements('noButton').forEach(
      (noButton: DefaultButton) => {
        noButton.controller.setSubmissionCallback(() => {
          this.setVisible(false);
        });
      },
    );

    this.setVisible(false);

    this.initializeResponsiveness();
  }

  open(callback: () => void) {
    this.handleCompleteCurrentLevel = callback;
    this.setVisible(true);
    PhaserAudioManager.playSFX(this.scene, 'npc_dialogue_open');
  }

  initializeResponsiveness() {
    // Responsiveness.
    ResponsivenessManager.InitializeResponsiveBreakpoints({
      scene: this.scene,
      desktopView: this.desktopView,
      mobileView: this.mobileView,
    });

    const anchor = getAnchorPlugin(this.scene);
    if (anchor) {
      anchor.add(this.mainContainer, {
        centerX: '50%',
        centerY: '50%',
      });
      anchor.add(this.mainContainer_m, {
        centerX: '50%',
        centerY: '50%',
      });
    }
  }
  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
